import { createSlice } from '@reduxjs/toolkit';
import { scrollLock as ScrollLock, scrollUnlock as ScrollUnlock } from './scrollLock';

const initialState = {
    alertTitle: '',
    mode: false,
  };
  
export const alertSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    openAlert: (state, actions) => {
      state.alertTitle = actions.payload;  
      state.mode = true;
      ScrollLock();
    },
    closeAlert: (state) => {
      state.alertTitle = '';
      state.mode = false;
      ScrollUnlock();
    },
  },
});

export const { openAlert, closeAlert } = alertSlice.actions;
export const selectAlert = (state) => state.alert;

export default alertSlice.reducer;